import React from 'react'

function Message() {
  return (
    <div>
        <div class="relative">
                    <div class="absolute inset-0 bg-fixed bg-cover bg-center" style={{
                        backgroundImage: "url('https://images.unsplash.com/photo-1590274853856-f22d5ee3d228?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
                    }}></div>
                    <div class="relative z-10 h-96 flex justify-center items-center bg-black bg-opacity-70">
                        <div class="container flex flex-col justify-center items-center">
                            <h1 class="mb-4 hover:underline hover:text-blue-100 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl"></h1>
                            <div class="mb-1">
                            </div>
                        </div>
                    </div>
                </div>


                     <div className= "bg-gradient-to-b from-blue-200 to-slate-200">
                    <div class="bg-gradient-to-b from-blue-200 to-white-200  max-w-screen-xl mx-auto py-8 px-4 lg:py-16 lg:px-6">
                    <div class="text-center mb-10">
                        <h2 class="text-4xl tracking-tight font-bold font-serif text-primary-800">Message from Principal</h2>

                    </div>


                    <div class="flex flex-col md:flex-row ">

                        <div class="mr-0 md:mr-8 mb-6 md:mb-0">

                            <div class="max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                                <a href="#">
                                    <img class="rounded-t-lg" src="https://i.ibb.co/cYCsJWj/principal-1.jpg" alt="" />
                                </a>
                                <div class="p-5">
                                </div>
                            </div>

                        </div>

                        <div class="sm:w-full p-1 whitespace-pre-wrap ">
                            <div class="text whitespace-normal">
                                <p class="text-gray-700 font-serif whitespace-pre-wrap">
                                    Greetings to everyone!!!
                                </p>
                                <p class="text-gray-700 font-serif font-semibold">

                                    Dear Students,

                                    I am delighted to announce that the VSPSMUN conference will be held on October 7th and 8th, 2023. This year's conference will be a great opportunity for students to learn about diplomacy, international relations, and the United Nations.
                                    The theme of this year's conference is "Global Cooperation for a Sustainable Future." We believe that this theme is particularly relevant given the current global challenges that we face. The conference will provide a platform for students to discuss and debate these issues and to come up with innovative solutions.


                                    Participating in the VSPSMUN conference will provide you with a unique opportunity to develop your leadership, communication, and critical thinking skills. You will also have the chance to meet and interact with students from different parts of the country and to learn about their cultures and perspectives.

                                    We encourage all students to participate in this year's conference.
                                    As the famous diplomat Kofi Annan once said, "Knowledge is power. Information is liberating. Education is the premise of progress, in every society, in every family." We believe that the VSPSMUN conference will provide you with the knowledge and information that you need to become a leader and a change-maker.
                                </p>
                                <p class="text-gray-700">
                                    DR Sushma Mandal,
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                </div>
    </div>
  )
}

export default Message